import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import StaticAdmin from "@/pages/StaticAdmin";
import { IS_STATIC } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("strovyn-theme") || "light"
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("strovyn-theme", theme);
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          {IS_STATIC ? (
            <>
              <Route
                path="/"
                element={<Home theme={theme} toggleTheme={toggleTheme} />}
              />
              <Route path="/buildweb" element={<StaticAdmin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <>
              <Route
                path="/"
                element={<Home theme={theme} toggleTheme={toggleTheme} />}
              />
              <Route path="/buildweb" element={<Admin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
